import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import Category from "../../images/category.png";
import AddCategory from "../../images/addCategory.png"
 

const Categories = () => {
  const CategoriesDoc = {
    title: "Categories",
    description: "Learn how to create and manage categories for easy product access.",
    sections: [
      {
        title: "Overview",
        content: "Categories help improve user experience by grouping similar products together, making them easier to find and navigate.",
        image: Category,
        imageAlt: "Category Dashboard",
        imageCaption: "Figure 1: Comprehensive view of the Categories Dashboard",
      },
      {
        title: "Category",
        content: "Add new product categories to organize products and enhance accessibility for users.",
        image: AddCategory,
        imageAlt: "Add Product Category",
        imageCaption: "Figure 2: Detailed view of the Add Product Category modal",
        subsections: [
          {
            title: "Add Category Steps",
            content: "Follow these steps to create a new category. Categories help users navigate to specific product groups easily.",
            steps: [
              "Main Category: Some categories serve as main categories, such as 'Fashion,' while others are subcategories (e.g., 'Shirts' under 'Fashion').\n - **Toggle On**: Select this option if the category is a main category.\n - **Toggle Off**: If the category is a subcategory, select its parent category (e.g., 'Fashion' as the parent of 'Shirts').",
              "Category Description: Provide a brief description to explain what products are included in this category. This helps users understand the category at a glance.",
              "Image: Upload an image representing this category (e.g., a representative photo of the product group). The image should be clear and visually related to the category.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...CategoriesDoc} />;
};

export default Categories;
